import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  occupancyTrackerList: { loading: false, data: null, error: null },
  leadReportList: { loading: false, data: null, error: null },
  salesReportList: { loading: false, data: null, error: null },
  topDealWonList: { loading: false, data: null, error: null },
  updateOtStatus: { loading: false, data: null, error: null },
  occupancyTrackerListFloorWise: { loading: false, data: null, error: null },
  occupancyGraphFloorWise: { loading: false, data: null, error: null },
  occupancyGraphSuiteFloorWise: { loading: false, data: null, error: null },
};

export const OccupancyTrackerSlice = createSlice({
  name: "occupancy",
  initialState,
  reducers: {
    fetchOccupancyListRequest: (state, action) => {
      state.occupancyTrackerList.loading = true;
      state.occupancyTrackerList.error = null;
    },
    fetchOccupancyListSuccess: (state, action) => {
      state.occupancyTrackerList.data = action.payload;
      state.occupancyTrackerList.loading = false;
      state.occupancyTrackerList.error = null;
    },
    fetchOccupancyListFailure: (state, action) => {
      state.occupancyTrackerList.data = null;
      state.occupancyTrackerList.loading = false;
      state.occupancyTrackerList.error = action.payload;
    },
    fetchLeadReportRequest: (state, action) => {
      state.leadReportList.loading = true;
      state.leadReportList.error = null;
    },
    fetchLeadReportSuccess: (state, action) => {
      state.leadReportList.data = action.payload;
      state.leadReportList.loading = false;
      state.leadReportList.error = null;
    },
    fetchLeadReportFailure: (state, action) => {
      // useKeyboardPickerState()
      state.leadReportList.data = null;
      state.leadReportList.loading = false;
      state.leadReportList.error = action.payload;
    },

    fetchSalesReportRequest: (state, action) => {
      state.salesReportList.loading = true;
      state.salesReportList.error = null;
    },
    fetchSalesReportSuccess: (state, action) => {
      state.salesReportList.data = action.payload;
      state.salesReportList.loading = false;
      state.salesReportList.error = null;
    },
    fetchSalesReportFailure: (state, action) => {
      state.salesReportList.data = null;
      state.salesReportList.loading = false;
      state.salesReportList.error = action.payload;
    },
    fetchTopDealWonRequest: (state, action) => {
      state.topDealWonList.loading = true;
      state.topDealWonList.error = null;
    },
    fetchTopDealWonSuccess: (state, action) => {
      state.topDealWonList.data = action.payload;
      state.topDealWonList.loading = false;
      state.topDealWonList.error = null;
    },
    fetchTopDealWonFailure: (state, action) => {
      state.topDealWonList.data = null;
      state.topDealWonList.loading = false;
      state.topDealWonList.error = action.payload;
    },
    fetchOccupancyListFloorRequest: (state, action) => {
      state.occupancyTrackerListFloorWise.loading = true;
      state.occupancyTrackerListFloorWise.error = null;
    },
    fetchOccupancyListFloorSuccess: (state, action) => {
      state.occupancyTrackerListFloorWise.data = action.payload;
      state.occupancyTrackerListFloorWise.loading = false;
      state.occupancyTrackerListFloorWise.error = null;
    },
    fetchOccupancyListFloorFailure: (state, action) => {
      state.occupancyTrackerListFloorWise.data = null;
      state.occupancyTrackerListFloorWise.loading = false;
      state.occupancyTrackerListFloorWise.error = action.payload;
    },
    fetchOccupancyGraphRequest: (state, action) => {
      state.occupancyGraphFloorWise.loading = true;
      state.occupancyGraphFloorWise.error = null;
    },
    fetchOccupancyGraphSuccess: (state, action) => {
      state.occupancyGraphFloorWise.data = action.payload;
      state.occupancyGraphFloorWise.loading = false;
      state.occupancyGraphFloorWise.error = null;
    },
    fetchOccupancyGraphFailure: (state, action) => {
      state.occupancyGraphFloorWise.data = null;
      state.occupancyGraphFloorWise.loading = false;
      state.occupancyGraphFloorWise.error = action.payload;
    },
    fetchOccupancyGraphSuiteRequest: (state, action) => {
      state.occupancyGraphSuiteFloorWise.loading = true;
      state.occupancyGraphSuiteFloorWise.error = null;
    },
    fetchOccupancyGraphSuiteSuccess: (state, action) => {
      state.occupancyGraphSuiteFloorWise.data = action.payload;
      state.occupancyGraphSuiteFloorWise.loading = false;
      state.occupancyGraphSuiteFloorWise.error = null;
    },
    fetchOccupancyGraphSuiteFailure: (state, action) => {
      state.occupancyGraphSuiteFloorWise.data = null;
      state.occupancyGraphSuiteFloorWise.loading = false;
      state.occupancyGraphSuiteFloorWise.error = action.payload;
    },
    updateOtStatusRequest: (state, action) => {
      state.updateOtStatus.loading = true;
      state.updateOtStatus.error = null;
    },
    updateOtStatusSuccess: (state, action) => {
      state.updateOtStatus.data = action.payload;
      state.updateOtStatus.loading = false;
      state.updateOtStatus.error = null;
    },
    updateOtStatusFailure: (state, action) => {
      state.updateOtStatus.data = null;
      state.updateOtStatus.loading = false;
      state.updateOtStatus.error = action.payload;
    },
  },
});

export const {
  fetchTopDealWonRequest,
  fetchTopDealWonSuccess,
  fetchTopDealWonFailure,
  fetchSalesReportRequest,
  fetchSalesReportSuccess,
  fetchSalesReportFailure,
  fetchLeadReportRequest,
  fetchLeadReportSuccess,
  fetchLeadReportFailure,
  fetchOccupancyListRequest,
  fetchOccupancyListSuccess,
  fetchOccupancyListFailure,
  updateOtStatusRequest,
  updateOtStatusSuccess,
  updateOtStatusFailure,
  fetchOccupancyListFloorRequest,
  fetchOccupancyListFloorSuccess,
  fetchOccupancyListFloorFailure,
  fetchOccupancyGraphRequest,
  fetchOccupancyGraphSuccess,
  fetchOccupancyGraphFailure,
  fetchOccupancyGraphSuiteRequest,
  fetchOccupancyGraphSuiteSuccess,
  fetchOccupancyGraphSuiteFailure,

} = OccupancyTrackerSlice.actions;

export const getOccupancyTrackerListState = (store) =>
  store.occupancy?.occupancyTrackerList;

  export const getLeadReportState = (store) =>
  store.occupancy?.leadReportList;

  export const getSalesReportState = (store) =>
  store.occupancy?.salesReportList;

  export const getTopDealWonState = (store) =>
  store.occupancy?.topDealWonList;

  export const getOccupancyTrackerListFloorState = (store) =>
  store.occupancy?.occupancyTrackerListFloorWise;

  export const getOccupancyGraphState = (store) =>
  store.occupancy?.occupancyGraphFloorWise;

  export const getOccupancyGraphSuiteState = (store) =>
  store.occupancy?.occupancyGraphSuiteFloorWise;

export default OccupancyTrackerSlice.reducer;
